import React from "react";

const Java_Generics = () => {
  return (
    <div>
      <h1>Java Generics</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Generics in Java.</p>
    </div>
  );
};

export default Java_Generics;
